import { NavigationGuardNext, Route } from 'vue-router';
import { PAGE_NAMES } from '@/constants';
import { ProjectDTO, UserDTO } from '@/models';
import store from '@/store';

const getCurrentUser = async (): Promise<UserDTO> => {
  const currentUser = await store.dispatch('app/fetchCurrentUser');
  return currentUser;
};

const canVisitAdminPage = async (next: NavigationGuardNext): Promise<void> => {
  const currentUser = await getCurrentUser();
  if (currentUser.isAdmin) {
    next();
  } else {
    next({ name: PAGE_NAMES.HOME });
  }
};

const canVisitProjectAdminPage = async (to: Route, next: NavigationGuardNext): Promise<void> => {
  const { projectId } = to.params;
  const currentUser = await getCurrentUser();
  let currentProject = store.getters['project/currentProject'] as ProjectDTO;
  if (!currentProject) {
    const { data } = await store.dispatch('project/asyncFetchProjectById', projectId);
    currentProject = data;
  }
  const canVisit =
    currentProject &&
    (currentUser.isAdmin ||
      currentUser.id === currentProject.manager.id ||
      currentUser.id === currentProject.sponsor.id);
  if (canVisit) {
    next();
  } else {
    next({ name: PAGE_NAMES.HOME });
  }
};

export { canVisitAdminPage, canVisitProjectAdminPage, getCurrentUser };
